import React, { Component } from 'react';
import VanillaTilt from 'vanilla-tilt';

const tiltOptionsDefault = {
	max: 22,
	speed: 500
};

const Tiltable = (WrappedComponent) => {
	class TiltableWrap extends Component {
		constructor(props) {
			super(props);
			this.el = React.createRef();
			this.tiltOptions = {...tiltOptionsDefault, ...props.tiltOptions };
		}
		componentDidMount() {
			VanillaTilt.init( this.el.current, this.tiltOptions);
		};
		componentWillUnmount() {
			this.el.current.vanillaTilt.destroy();
		}
		render() {
			return (
				<div className="Tiltable" ref={this.el}>
					<WrappedComponent {...this.props} />
				</div>
			);
		}
	}

	return TiltableWrap;
}

export default Tiltable;


// WEBPACK FOOTER //
// ./src/components/common/Tiltable.jsx